import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transportation-route-info p-4 d-flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = { class: "transportation-route-title font-weight-600" }
const _hoisted_3 = { class: "container w-100 p-0" }
const _hoisted_4 = { class: "row row-cols-4 align-items-center justify-content-center" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "col-3 p-2" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-3 p-2" }
const _hoisted_9 = { class: "row row-cols-4 align-items-center justify-content-center" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "col-3 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.transportationData.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-3 d-flex justify-content-center" }, [
          _createElementVNode("img", {
            src: "/assets/images/frame-arrow.svg",
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.transportationData.pickup_time), 1),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "vr vertical-line" }, null, -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.transportationData.pickup_city.address_to_show), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportationData.transportation_stop, (stop) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row row-cols-4 align-items-center justify-content-center",
          key: stop.id
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-3 d-flex justify-content-center" }, [
            _createElementVNode("img", {
              src: "/assets/images/one-dot.svg",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(stop.time), 1),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "vr vertical-line" }, null, -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(stop.transportation_address.address_to_show), 1)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-3 d-flex justify-content-center" }, [
          _createElementVNode("img", {
            src: "/assets/images/frame-flag.svg",
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.transportationData.drop_off_time), 1),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "vr vertical-line" }, null, -1)),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.transportationData.dropoff_city.address_to_show), 1)
      ])
    ])
  ]))
}